import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getDateWithoutTime } from 'components/global/utils';
import { UndeliveredParams, UndeliveredPhase } from '@api/order-reporting/types/UndeliveredParams';
import { UndeliveredOrdersReport } from '@api/order-reporting/types/UndeliveredOrdersReport';
import { UndeliveredGridData } from '@pages/reporting-pages/undelivered-orders/types/UndeliveredGridData';
import { convertToGridData } from '@pages/reporting-pages/undelivered-orders/store/convertors';
import { DateRange } from '@project-types/DateRange';



interface ReportingUndeliveredState {
	gridData: UndeliveredGridData[] | null,
	dateRange: DateRange | null,
	selectedPlant: string | null,
	phase: string | null,
};

const initialState: ReportingUndeliveredState = {
	gridData: null,
	dateRange: null,
	selectedPlant: null,
	phase: UndeliveredPhase.execution,
};



export const reportingUndeliveredSlice = createSlice({
	name: 'reportingUndelivered',
	initialState,
	reducers: {
		createGridData: (state, action: PayloadAction<UndeliveredOrdersReport[] | undefined | null>) => {
			state.gridData = convertToGridData(action.payload);
		},
		setDateRange: (state, action: PayloadAction<DateRange>) => {
			state.dateRange = action.payload;
		},
		setSelectedPlant: (state, action: PayloadAction<string | null>) => {
			state.selectedPlant = action.payload;
		},
		setPhase: (state, action: PayloadAction<string | null>) => {
			state.phase = action.payload;
		},
		setSearchParameters: (state, action: PayloadAction<UndeliveredParams>) => {
			let stateFrom = state.dateRange ? state.dateRange.from : null;
			let paramFrom = action.payload.dateFrom ? getDateWithoutTime(action.payload.dateFrom) : null;
			let stateTo = state.dateRange ? state.dateRange.to : null;
			let paramTo = action.payload.dateTo ? getDateWithoutTime(action.payload.dateTo) : null;
			if (stateFrom !== paramFrom || stateTo !== paramTo) {
				state.dateRange = paramFrom && paramTo ? { from: paramFrom, to: paramTo } : null;
			}
			if (action.payload.dc !== state.selectedPlant) {
				state.selectedPlant = action.payload.dc ? action.payload.dc : null;
			}
		},
		resetStore: (_) => initialState,
	},
});



export const {
	createGridData,
	setDateRange,
	setSelectedPlant,
	setPhase,
	setSearchParameters,
	resetStore } = reportingUndeliveredSlice.actions;